<script>
    import { onMount } from "svelte";
    import axios from "axios";
    import moment from "moment";

    let loading = false;
    let mounted;
    let specs = [], spec;
    let doctors = [], doc;
    let services = [], service;
    let times = {}, time = null, date;
    let lastName, firstName, middleName;
    let birthDay, birthMonth, birthYear, phone = "8";
    const days = [], months = [], years = [];
    let phoneErr, lastNameErr, firstNameErr, middleNameErr, bdErr;
    let timer;
    let submitErr = "", submitSuccess = false;

    $: getDoctors(spec);
    $: getServices(doc);
    $: getTimes(service);
    $: filterFIO(lastName, firstName, middleName);
    $: filterPhone(phone);

    onMount( () => {
        document.body.scrollTo({
            top: 0,
            behavior: 'smooth'
        });

        mounted = true;
        getSpecs();

        for(let i=1;i<=31;i++) {
            if(i < 10) days.push(`0${i}`);
            else days.push(i);
        }
        for(let i=1;i<=12;i++) {
            if(i < 10) months.push(`0${i}`);
            else months.push(i);
        }

        const maxYear = new Date().getFullYear();
        const minYear = maxYear - 100;
        for(let i=maxYear; i>=minYear; i--) years.push(i);
    });

    const capitalize = str => str.charAt(0).toUpperCase() + str.slice(1);

    const filterFIO = () => {
        try {
            if(lastName) {
                lastName = lastName.replace(/[^а-яА-Я]/gi,"");
                lastName = capitalize(lastName);
            }

            if(firstName) {
                firstName = firstName.replace(/[^а-яА-Я]/gi,"");
                firstName = capitalize(firstName);
            }

            if(middleName) {
                middleName = middleName.replace(/[^а-яА-Я]/gi,"");
                middleName = capitalize(middleName);
            }
        }
        catch(err) {
            console.log(err);
        }
    };

    const filterPhone = () => {
        try {
            phone = phone.replace(/\D/gi, "");
            if(phone.length === 0) phone = "8";
        }
        catch(err) {
            console.log(err);
        }
    };

    const submit = async () => {

        const bd = `${birthYear}-${birthMonth}-${birthDay}`;//moment().date(birthDay).month(birthMonth-1).year(birthYear);

        submitErr = "";
        submitSuccess = false;

        if(!(phone && phone.length === 11)) phoneErr = "Укажите номер телефона";
        if(!lastName || lastName.length < 2) lastNameErr = "Укажите фамилию";
        if(!firstName || firstName.length < 2) firstNameErr = "Укажите имя";
        if(!middleName || middleName.length < 2) middleNameErr = "Укажите отчество";
        if(!moment(bd).isValid()) bdErr = "Укажите дату рождения";

        if(phoneErr || lastNameErr || firstNameErr || middleNameErr || bdErr) {
            timer = setTimeout(function (){
                const el = document.querySelector(".error-message");
                if(el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
                clearTimeout(timer);
            }, 150);
            return;
        }

        loading = true;

        try {
            const form = {
                name: firstName,
                lastname: lastName,
                secondname: middleName,
                birthdate: bd,
                phone: phone,
                date: time.timestamp,
                doc: doc['Врач'],
                service: service['Номенклатура'],
                dms: false,
                isOnline: false,
                roistat: "online-zapis"
            };

            const encodedForm = new URLSearchParams(form).toString();

            const { data } = await axios.post(
                `https://api.medeor74.ru/setZapis`,
                encodedForm,
                {
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded"
                    }
                }
            );

            if(data.success === true) submitSuccess = true;
            else {
                submitSuccess = false;
                submitErr = "Ошибка при записи на приём";
            }
        }
        catch(err) {
            submitErr = "Ошибка при записи на приём";
            console.log(err);
        }

        loading = false;

        document.body.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    const getSpecs = async () => {
        loading = true;

        doctors = [];
        doc = null;
        services = [];
        service = null;
        times = {};
        time = null;
        date = null;

        try {
            const { data } = await axios.get("https://api.medeor74.ru/getSpecs/");
            specs = data;
        }
        catch(err) {
            console.log(err);
        }

        loading = false;
    };

    const getDoctors = async () => {
        if(!mounted) return;
        if(!spec) return;

        loading = true;

        doc = null;
        services = [];
        service = null;
        times = {};
        time = null;
        date = null;

        try {
            const { data } = await axios.get(`https://api.medeor74.ru/getDoctors/${spec['Специальность']}`);
            doctors = data;
            if(doctors.length === 1) doc = doctors[0];
        }
        catch(err) {
            console.log(err);
        }

        loading = false;
    };

    const getServices = async () => {
        if(!mounted) return;
        if(!doc) return;

        times = {};
        time = null;
        date = null;
        service = null;
        services = [];

        loading = true;

        try {
            const { data } = await axios.get(`https://api.medeor74.ru/getUslugi/${doc['Врач']}`);
            services = data;
            if(services.length === 1) service = services[0];
        }
        catch(err) {
            console.log(err);
        }

        loading = false;
    };

    const getTimes = async () => {
        if(!(service && service['Номенклатура'] )) return;
        if(!(doc && doc['Врач'] )) return;

        date = null;
        time = null;

        try {
            const { data } = await axios.get(`https://api.medeor74.ru/getFreeTime/${doc['Врач']}/${service['Номенклатура']}/`);

            if(!data.length) return;

            times = {};

            data.forEach( item => {
                const date = moment(item['ПериодС']).format("DD.MM");

                if(!times[date]) times[date] = {
                    label: date,
                    sort: moment(item['ПериодС']).format("Z"),
                    times: []
                };

                times[date].times.push({
                    timestamp: item['ПериодС'],
                    label: moment(item['ПериодС']).format("HH:mm")
                });
            });

            date = Object.keys(times)[0];
        }
        catch(err) {
            console.log(err);
        }
    }

    const selectDate = (e,t) => {
        e.target.scrollIntoView({ behavior: "smooth", inline: "center", block: "center" });
        date = t;
    };

    const selectTime = (t) => {
        document.body.scrollTo({
            top: 0,
            behavior: 'smooth'
        });

        time = t;
    }

    const changeChoice = () => {
        time = null;
        submitErr = "";
        submitSuccess = false;
    }
</script>

<div class="container" style="max-width: 600px;">

    <div class="text-center">
        <a href="https://medeor74.ru">
            <img class="img-fluid mt-3" src="https://medeor74.ru/wp-content/uploads/2017/11/logo-dark.png">
        </a>
    </div>

    <div class="text-center h4 mt-4">
        Онлайн-запись на приём
    </div>

    <div class="jumbotron rounded-lg mt-4 p-3" id="online-widget-svelte-wrap">

        {#if time}
            {#if submitSuccess}
                <div class="content-block text-center">
                    <p>
                        Ваша запись успешно оформлена!
                    </p>
                    <div>
                        Благодарим Вас за обращение.
                    </div>
                </div>
            {:else}
                <div class="">
                    <button class="btn btn-outline-light rounded-lg" on:click={ changeChoice }>
                        <i class="fas fa-chevron-left"></i>
                        Изменить выбор
                    </button>
                </div>

                {#if submitErr}
                    <div class="content-block text-center mt-3">
                        <p>
                            Не удалось оформить запись.
                        </p>
                        <div>
                            Попробуйте выбрать другое время.
                        </div>
                    </div>
                {:else}
                    <div>
                        <div class="mt-3 content-block">
                            <p>
                                Запись на приём к специалисту { doc['Фамилия'] } { doc['Имя'] } { doc['Отчество'] }.
                            </p>
                            <p>
                                Услуга: { service['Наименование'] }
                            </p>
                            <p>
                                Стоимость: { service['Цена'] } руб.
                            </p>
                            <div>
                                Дата и время: { date } в { time.label }
                            </div>
                        </div>
                        <div class="mt-3 content-block">
                            <p class="text-center">
                                <b>
                                    Укажите свои контактные данные
                                </b>
                            </p>
                            <div>
                                <div>
                                    Фамилия
                                </div>
                                <input type="text" class="rounded-lg form-control" bind:value={lastName}>
                                {#if lastNameErr}
                                    <div class="error-message">
                                        { lastNameErr }
                                    </div>
                                {/if}
                            </div>
                            <div class="mt-3">
                                <div>
                                    Имя
                                </div>
                                <input type="text" class="rounded-lg form-control" bind:value={firstName}>
                                {#if firstNameErr}
                                    <div class="error-message">
                                        { firstNameErr }
                                    </div>
                                {/if}
                            </div>
                            <div class="mt-3">
                                <div>
                                    Отчество
                                </div>
                                <input type="text" class="rounded-lg form-control" bind:value={middleName}>
                                {#if middleNameErr}
                                    <div class="error-message">
                                        { middleNameErr }
                                    </div>
                                {/if}
                            </div>
                            <div class="mt-3">
                                <div>
                                    Номер телефона
                                </div>
                                <input type="text" maxlength="11" class="rounded-lg form-control" bind:value={phone} inputmode="numeric">
                                {#if phoneErr}
                                    <div class="error-message">
                                        { phoneErr }
                                    </div>
                                {/if}
                            </div>
                            <div class="mt-3">
                                <div>
                                    Дата рождения
                                </div>
                                <div class="bd-wrap">
                                    <select class="form-control rounded-lg text-center" bind:value={birthDay}>
                                        {#each days as d}
                                            <option value={d}>
                                                { d }
                                            </option>
                                        {/each}
                                    </select>
                                    <div>.</div>
                                    <select class="form-control rounded-lg text-center" bind:value={birthMonth}>
                                        {#each months as d}
                                            <option value={d}>
                                                { d }
                                            </option>
                                        {/each}
                                    </select>
                                    <div>.</div>
                                    <select class="form-control rounded-lg text-center" bind:value={birthYear}>
                                        {#each years as d}
                                            <option value={d}>
                                                { d }
                                            </option>
                                        {/each}
                                    </select>
                                </div>
                                {#if bdErr}
                                    <div class="error-message">
                                        { bdErr }
                                    </div>
                                {/if}
                            </div>
                        </div>
                        <div class="content-block mt-3 text-center">
                            <p>
                                Нажимая на кнопку «Отправить», я подтверждаю что ознакомлен с <a href="https://medeor74.ru/soglasie-na-obrabotku-personalnyh-dannyh/" target="_blank">Политикой обработкой персональных данных</a>.
                            </p>
                            <div>
                                При регистрации я даю свое согласие на обработку моей персональной информации в соответствии с Политикой  обработки  персональных данных
                            </div>
                        </div>
                        <div class="text-center mt-3">
                            <button type="button" class="btn btn-light rounded-lg px-4" on:click={ submit }>
                                Отправить
                            </button>
                        </div>
                    </div>
                {/if}
            {/if}
        {:else}
            <div>
                <div>
                    Специальность
                </div>
                {#if specs.length}
                    <select class="form-control rounded-lg" bind:value={spec}>
                        <option value={null}>
                            Выберите специальность
                        </option>
                        {#each specs as s (s['Специальность'])}
                            <option value={s}>
                                { s['Представление'] }
                            </option>
                        {/each}
                    </select>
                {:else}
                    <div class="rounded-lg p-3 text-center border">
                        <p>
                            Не удалось получить список специальностей.
                        </p>
                        <div>
                            Попробуйте обновить страницу.
                        </div>
                    </div>
                {/if}
            </div>

            {#if spec}
                <div class="mt-3">
                    {#if doctors && doctors.length}
                        <div class="mt-3">
                            Врачи с выбранной специальностью
                        </div>
                        <select class="form-control rounded-lg" bind:value={doc}>
                            <option value={null}>
                                Выберите врача
                            </option>
                            {#each doctors as s (s['Врач'])}
                                <option value={s}>
                                    { s['Фамилия'] } { s['Имя'] } { s['Отчество'] }
                                </option>
                            {/each}
                        </select>
                    {:else}
                        <div class="content-block text-center">
                            Специалисты не найдены
                        </div>
                    {/if}
                </div>
            {/if}

            {#if doc}
                <div class="mt-3">
                    <div class="mb-3" class:d-none={!doc['КраткоеОписание']}>
                        <div>
                            Информация о враче-специалисте
                        </div>
                        <div class="content-block">
                            { doc['КраткоеОписание'] }
                        </div>
                    </div>

                    {#if services.length === 0}
                        <div class="content-block text-center">
                            Услуги не найдены
                        </div>
                    {/if}

                    {#if services.length === 1}
                        <div class="mt-3">
                            Услуга
                        </div>
                        <div class="content-block">
                            { service['Наименование'] }
                        </div>
                    {/if}

                    {#if services.length > 1}
                        <div class="mt-3">
                            Услуги
                        </div>
                        <select class="form-control rounded-lg" bind:value={service}>
                            <option value={null}>
                                Выберите услугу
                            </option>
                            {#each services as s (s['Номенклатура'])}
                                <option value={s}>
                                    { s['Наименование'] }
                                </option>
                            {/each}
                        </select>
                    {/if}
                </div>

                {#if service}
                    <div class="mt-3">
                        <div class="content-block d-flex align-items-center justify-content-between">
                            <div>
                                Стоимость
                            </div>
                            <div>
                                { service['Цена'] } руб.
                            </div>
                        </div>
                    </div>
                {/if}
            {/if}

            {#if service}
                {#if Object.keys(times).length}
                    <div class="mt-3">
                        <div>
                            Даты приёма
                        </div>
                        <div class="content-block" style="overflow-x: hidden; padding: 0;">
                            <div class="dates-wrap">
                                {#each Object.keys(times) as t}
                                    <div
                                            class="time-btn"
                                            class:selected-block={ date === t }
                                            on:click={ (e) => selectDate(e,t) }
                                    >
                                        { t }
                                    </div>
                                {/each}
                            </div>
                        </div>

                        {#if date}
                            <div class="mt-3">
                                Время приёма
                            </div>
                            <div class="content-block">
                                <div class="times-wrap">
                                    {#each times[date].times as t}
                                        <div class="time-btn" on:click={ () => selectTime(t) }>
                                            { t.label }
                                        </div>
                                    {/each}
                                </div>
                            </div>
                        {/if}
                    </div>
                {:else}
                    <div class="mt-3 content-block text-center">
                        Нет свободного времени для записи
                    </div>
                {/if}
            {/if}
        {/if}
    </div>

    <div class="bg-white text-center rounded-lg border p-3">
        <div>
            Уважаемые пациенты! Запись на услуги по полису ДМС осуществляется только через колл-центр по телефону:
        </div>
        <div>
            <a href="tel:+73512778808">
                +7 (351) 277-88-08
            </a>
        </div>
    </div>

    <div class="bg-white text-center rounded-lg border p-3 mt-3">
        <p>
            Вы уже были на очном приёме у врача-специалиста и вам требуется скорректировать план лечения или получить дополнительную консультацию?
        </p>
        <p>
            Вы можете сделать это в онлайн-формате.
        </p>
        <p>
            Просто скачайте приложение "МЦ Медеор" в App Store или Google Play.
        </p>
        <div>
            <a href="https://onelink.to/zqp4rf" class="btn btn-outline-dark">
                Скачать приложение
            </a>
        </div>
    </div>

    <div class="d-none d-lg-block bg-white text-center rounded-lg border p-3 mt-3">
        <img src="qr.png" class="img-fluid" width="150" alt="">
        <div class="mt-3">
            Отсканируйте QR-код,<br>
            чтобы скачать мобильное приложение
        </div>

    </div>
</div>

{#if loading}
    <div class="loader">
        <div class="spinner spinner-border"></div>
    </div>
{/if}

<style>
    .error-message {
        color: #fff;
        background-color: #f00;
        padding: 10px;
        margin-top: 5px;
        border-radius: 1rem;
        text-align: center;
    }

    .bd-wrap {
        display: grid;
        grid-template-columns: 1fr max-content 1fr max-content 2fr;
        grid-gap: 5px;
        align-items: end;
    }

    .confirm-appointment {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 3;
        background: #fff;
    }

    .times-wrap {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(65px,1fr));
        grid-gap: 10px;
    }

    .times-wrap .time-btn {
        width: 100%;
    }

    .selected-block {
        background: var(--bordo) !important;
        color: #fff!important;
    }

    .time-btn {
        border: 1px solid var(--bordo);
        padding: 0.5rem 0;
        border-radius: 10px;
        min-width: 65px;
        width: 65px;
        text-align: center;
        cursor: pointer;
    }

    .content-block {
        background: #fff;
        color: #000;
        border-radius: 1rem;
        padding: 1rem;
    }

    .dates-wrap {
        display: flex;
        align-items: center;
        gap: 10px;
        overflow-x: scroll;
        padding: 1rem;
    }

    .spinner {
        color: var(--bordo)!important;
    }

    .loader {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 100;
        backdrop-filter: blur(10px);
        -webkit-backdrop-filter: blur(10px);
        display: flex;
        align-items: center;
        justify-content: center;
    }
</style>